import { HttpClient, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ConfirmOrReprocessUploadRequestDTO } from "../../schema/Streaming/ConfirmOrReprocessUploadRequestDTO";
import { GenerateUploadUrlRequestDTO } from "../../schema/Streaming/GenerateUploadUrlRequestDTO";

import { UploadUrlPreSignedDTO } from "../../schema/Streaming/UploadUrlPreSignedDTO";

@Injectable({
    providedIn: "root"
})
export class ApiUploadService {
    basePath = `${environment.streaming.url}/api/v1/upload`;

    constructor(private http: HttpClient) {}

    getPresignUploadUrl(request: GenerateUploadUrlRequestDTO): Observable<UploadUrlPreSignedDTO> {
        const url = `${this.basePath}/generate-url`;
        return this.http.post<UploadUrlPreSignedDTO>(url, request);
    }

    uploadWithPresignedUrl(url: string, file: File): Observable<HttpEvent<any>> {
        return this.http.put(url, file, {
            headers: new HttpHeaders({ "Content-Type": file.type || "application/octet-stream" }),
            observe: "events",
            reportProgress: true
        });
    }

    confirmUpload(request: ConfirmOrReprocessUploadRequestDTO) {
        return this.http.post<void>(`${this.basePath}/confirm`, request);
    }

    googleDriveUpload(request: GenerateUploadUrlRequestDTO): Observable<UploadUrlPreSignedDTO> {
        const url = `${this.basePath}/google-drive`;
        return this.http.post<UploadUrlPreSignedDTO>(url, request);
    }

    reprocessVideo(request: ConfirmOrReprocessUploadRequestDTO): Observable<void> {
        return this.http.post<void>(`${this.basePath}/reprocessVideo/${request.courseId}`, request);
    }
}
